import { asset } from "../lib/api";
import { Printer } from "lucide-react";

export const PhotoCard = ({ photo, index = 0, onBuy }) => (
  <div
    data-testid={`photo-card-${photo.id}`}
    className="group relative overflow-hidden rounded-lg border border-white/10 bg-obsidian-800 animate-fade-up"
    style={{ animationDelay: `${index * 50}ms` }}
  >
    <div className="aspect-[3/4] overflow-hidden">
      <img src={asset(photo.image_url)} alt={photo.title} loading="lazy"
        className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
    </div>
    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent opacity-90" />
    <div className="absolute bottom-0 inset-x-0 p-4">
      <div className="overline-label mb-0.5">{photo.category}</div>
      <h3 className="font-serif text-xl font-light">{photo.title || photo.category}</h3>
      {photo.for_sale !== false && (
        <button
          data-testid={`buy-photo-${photo.id}`}
          onClick={() => onBuy(photo)}
          className="mt-3 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 btn-amber rounded-full px-4 py-2 text-sm flex items-center gap-2"
        >
          <Printer size={14} /> Order as print
        </button>
      )}
    </div>
  </div>
);
